<template>
  <b-card no-body v-draggable 
          class="lead-mgmt-popup"
          :style="{ 'width': `${popupWidth}px` }"
          >
    <b-card-header  class="lead-mgmt-popup-header"
                    header-tag="div"
                    header-bg-variant="dark">
      <div>
        <strong>{{ title }}</strong>
      </div>
      <font-awesome-icon  class="cx-close-icon mx-1 clickable" 
                          :icon="['far', 'times']"
                          @click="$emit('close')" />
    </b-card-header>
    <slot>
      <div class="dummy-content">Popup content ...</div>
    </slot>
  </b-card>
</template>

<script>
export default {
  props: {
    title: { type: String, default: 'Header empty ...' },
    popupWidth: { type: Number, default: 1024 }
  }
}
</script>

<style scoped>
  .lead-mgmt-popup {
    box-shadow: 3px 3px 13px -3px var(--border-color-secondary);
    border: none;
    position: fixed !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    overflow: auto;
    width: 600px;
    min-height: 25vh !important;
    max-height: 90vh;
  }

  .lead-mgmt-popup-header {
    display: grid;
    grid-template-columns: 1fr auto; 
    color: lightgrey; 
    padding: 0.25rem 0.5rem!important;
    height: 32px; 
    cursor: move;
  }

  .dummy-content {
    padding: 40% 40%;
  }
</style>